import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Observable } from 'rxjs';
import { BaseService } from 'src/app/core/base/base.service';
import { RestService } from 'src/app/core/service/rest.service';
import { PatientDialogComponent } from 'src/app/main/common/patient/components/patient-dialog.component';
import { PatientService } from 'src/app/main/common/patient/patient.service';
import { PersonService } from 'src/app/main/common/person/person.service';
import { CONSULT_PATIENT } from './consult-patient.constants';

@Injectable({
  providedIn: 'root'
})
export class ConsultPatientService extends BaseService {

  readonly screen = CONSULT_PATIENT;

  constructor(
    override store: Store<any>,
    protected rest: RestService,
    protected router: Router,
    protected dialogService: DialogService,
    protected patientService: PatientService,
    protected personService: PersonService
  ) {
    super();
  }

  readHistoryPdfStore = (): Observable<boolean> =>
    this.store.select('core', 'consultPatient', 'historyPdf')

  getPatientById = this.patientService.getPatientById;

  getPersonById = this.personService.getPersonById;

  openPatientDialog = (): DynamicDialogRef =>
    this.dialogService.open(PatientDialogComponent, {
      data: {
        save: this.patientService.save,
      },
      header: this.screen.actions.editPatient,
      closeOnEscape: true,
      width: '75%'
    })

}
